import { workflowBasePart } from "./constants";

export default {
  all: () => `${workflowBasePart}/tasks`,
  byId: (id: string) => `${workflowBasePart}/tasks/${id}`,
};
